var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    fillRule: "evenodd",
    d: "M0 16.297c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.164-16-16",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36 10.815a7.2 7.2 0 0 1-1.975.542 3.4 3.4 0 0 0 1.508-1.895 6.9 6.9 0 0 1-2.174.83 3.427 3.427 0 0 0-5.93 2.344c.001.272.024.533.08.782a9.7 9.7 0 0 1-7.065-3.586c-.296.513-.47 1.1-.47 1.733 0 1.187.612 2.24 1.523 2.849a3.4 3.4 0 0 1-1.549-.423v.038a3.444 3.444 0 0 0 2.747 3.368c-.28.076-.583.113-.899.113-.22 0-.44-.013-.649-.058a3.46 3.46 0 0 0 3.203 2.387 6.9 6.9 0 0 1-4.25 1.462c-.281 0-.55-.012-.82-.047a9.65 9.65 0 0 0 5.258 1.539c6.308 0 9.757-5.225 9.757-9.755q0-.226-.013-.443a6.8 6.8 0 0 0 1.718-1.78"
  }))));
};
export default SvgTwitter;